import {
  ApiResponse,
  CashDiscountGrouped,
  DiscountMasterData,
  CreateApplyDiscount,
  ListSort,
} from '../models';
import * as http from './http';
import ApiService from './service';
import { LeadConfiguration } from '../models/configuration';
import { Dict, PaginatedApiResponse } from '../..';

export class DiscountService extends ApiService {
  public async getDiscountData(configId: string) {
    const url = `${this.apiDomain}/api/configuration/${configId}/discount/data`;

    const resposne = await http.get<ApiResponse<DiscountMasterData>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }

  async applyVehicleDiscount(data: CreateApplyDiscount, configId: string) {
    const url = `${this.apiDomain}/api/configuration/${configId}/discount/vehicle`;
    const response = await http.post<ApiResponse<LeadConfiguration>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  async applyTradeInDiscount(data: CreateApplyDiscount, configId: string) {
    const url = `${this.apiDomain}/api/configuration/${configId}/discount/tradeIn`;
    const response = await http.post<ApiResponse<LeadConfiguration>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  async approveDiscount(
    data: CreateApplyDiscount,
    configId: string,
    discountId: string
  ) {
    const url = `${this.apiDomain}/api/configuration/${configId}/discount/${discountId}/approve`;
    const response = await http.put<ApiResponse<LeadConfiguration>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  async rejectDiscount(
    data: CreateApplyDiscount,
    configId: string,
    discountId: string
  ) {
    const url = `${this.apiDomain}/api/configuration/${configId}/discount/${discountId}/reject`;
    const response = await http.put<ApiResponse<LeadConfiguration>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  async deleteDiscount(configId: string, discountId: string) {
    const url = `${this.apiDomain}/api/configuration/${configId}/discount/${discountId}`;
    const response = await http.remove<ApiResponse<LeadConfiguration>>(
      url,
      this.store
    );
    return response.data;
  }

  async activateDiscount(
    data: CreateApplyDiscount,
    configId: string,
    discountId: string
  ) {
    const url = `${this.apiDomain}/api/configuration/${configId}/discount/${discountId}/activate`;
    const response = await http.put<ApiResponse<LeadConfiguration>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  async deactivateDiscount(
    data: CreateApplyDiscount,
    configId: string,
    discountId: string
  ) {
    const url = `${this.apiDomain}/api/configuration/${configId}/discount/${discountId}/deactivate`;
    const response = await http.put<ApiResponse<LeadConfiguration>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  async applyAccessoriesDiscount(data: CreateApplyDiscount, configId: string) {
    const url = `${this.apiDomain}/api/configuration/${configId}/discount/accessories`;
    const response = await http.post<ApiResponse<LeadConfiguration>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async getDiscountSummary(
    discountType: string,
    data: {
      page: number;
      search?: string;
      perPage: number;
      isDeal?: boolean;
      customerId?: string;
    } & ListSort &
      Dict
  ): Promise<
    PaginatedApiResponse<LeadConfiguration> & { lastUpdatedAt: Date }
  > {
    const url = `${this.apiDomain}/api/configuration/discounts/${discountType}`;

    const resposne = await http.post<PaginatedApiResponse<LeadConfiguration>>(
      url,
      data,
      this.store
    );
    return { ...resposne.data, lastUpdatedAt: new Date() };
  }

  public async downloadDiscountSummary(
    discountType: string,
    data: {
      search?: string;
      columns: { label: string; source?: string }[];
      isDeal?: boolean;
    } & ListSort &
      Dict
  ): Promise<void> {
    const url = `${this.apiDomain}/api/configuration/discounts/${discountType}/download`;

    const resposne = await http.downloadPostData(url, data, this.store);
    http.saveDownloadedFile(
      resposne.data,
      'application/application/vnd.openxmlformats',
      `DiscountSummary-${new Date()}.xlsx`
    );
  }
}
